import {Injectable} from '@angular/core';
import {UiStore} from './ui.store';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class UiService {

  subTitle$ = new BehaviorSubject<string>(null);

  constructor(private uiStore: UiStore) {
  }

  btnLoadStart(id: string) {
    this.uiStore.update({loadingBtn: id});
  }

  btnLoadEnd() {
    this.uiStore.update({loadingBtn: null});
  }

  httpLoading(val: boolean) {
    this.uiStore.update({httpLoading: val});
  }

  error(msg: string) {
    this.uiStore.update({errorMessage: {timestamp: new Date(), message: msg}});
  }

  info(msg: string) {
    this.uiStore.update({infoMessage: {timestamp: new Date(), message: msg}});
  }

  setSubtitle(title: string) {
    this.subTitle$.next(title);
  }

}
